import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import { paginate } from './paginate'

class PromoItem {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })
    this.promoItem = base
  }
  
  async post (data) {
    await AuthToken.setAuth(this.promoItem)

    return this.promoItem({
      url: `/promo_item`,
      method: 'POST',
      data: data
    })
  }

  async put (promo_item_id, data) {
    await AuthToken.setAuth(this.promoItem)

    return this.promoItem({
      url: `/promo_item/${promo_item_id}`,
      method: 'PUT',
      data
    })
  }

  async getItemsByGroup (promo_item_group_id) {
    await AuthToken.setAuth(this.promoItem)
    return this.promoItem({
      url: `/promo_items/${promo_item_group_id}`,
      method: 'GET'
    })
  }

  async getItemsByPromo (
    { promo_id, offset = 0, limit = 50, paging = false, callback = null, check_allowances = false,
      item_id_filter = null, upc_filter = null, description_filter = null, source_filter = null, item_group_name_filter = null, vendor_filter = null
    }
  ) {
    await AuthToken.setAuth(this.promoItem)

    if (paging) {
      const url = `/promo_items/promo/${promo_id}`
      return paginate(this.promoItem, url, limit, offset, callback, {
        check_allowances, item_id_filter, upc_filter, description_filter, source_filter, item_group_name_filter, vendor_filter, dataKey: 'items'
      })
    }
    return this.promoItem({
      url: `/promo_items/promo/${promo_id}`,
      method: 'GET',
      params: { offset, limit, check_allowances, item_id_filter, upc_filter, description_filter, source_filter, item_group_name_filter, vendor_filter }
    })
  }

  async getUniqueItemsByPromo (promo_id) {
    await AuthToken.setAuth(this.promoItem)
    return this.promoItem({
      url: `/promo_items/unique_items/${promo_id}`,
      method: 'GET'
    })
  }

  async getItem (promo_item_id) {
    await AuthToken.setAuth(this.promoItem)
    return this.promoItem({
      url: `/promo_item/${promo_item_id}`,
      method: 'GET'
    })
  }

  async delete (promo_item_id) {
    await AuthToken.setAuth(this.promoItem)

    return this.promoItem({
      url: `/promo_item/${promo_item_id}`,
      method: 'DELETE'
    })
  }

  async deleteGroup (data) {
    await AuthToken.setAuth(this.promoItem)
    return this.promoItem({
      url: `/promo_items`,
      method: 'DELETE',
      data: data
    })
  }
}

export default new PromoItem()